// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Gj-z","tupacHeader":"Hj-z","tupacHeader2":"Ij-z","tupacMenu":"Jj-z","tupacMenu2":"Kj-z","tupacMain":"Lj-z","tupacMain2":"Mj-z"};